exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ivu-layout-footer[data-v-6ccc1355]{background-color:#1f2d3d;color:#fff}.ivu-layout-footer>div[data-v-6ccc1355]{width:1000px;margin:0 auto;overflow:hidden}.ivu-layout-footer>div img[data-v-6ccc1355]{width:144px;float:left}.ivu-layout-footer>div>div[data-v-6ccc1355]{float:left;margin-left:40px}.ivu-layout-footer>div>div p[data-v-6ccc1355]{margin:36px 0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-6ccc1355","scoped":true,"hasInlineConfig":false}!./node_modules/less-loader/dist/cjs.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./node_modules/iview-loader??ref--0-1!./src/components/footerItem.vue
// module id = pSWh
// module chunks = 1